import {
  faEye as eye,
  faStar as star,
} from '@fortawesome/free-solid-svg-icons';

import { TrlFormattedMessagePlain } from '»utils/i18n';

import { EyeIconStyled, StarIconStyled } from './TrlSecuritiesAccounts.styles';

export const columns = ({
  handleVisibleChange,
  favoriteValue,
  handleFavoriteChange,
  isLarge,
  isMedium,
  isExtraLarge,
}) => {
  const getAccountWidth = () => {
    if (isMedium) return '220px';

    return 'auto';
  };

  const getAccountDescrWidth = () => {
    if (isExtraLarge) return '180px';

    if (isLarge) return '160px';

    if (isMedium) return 'auto';

    return 0;
  };

  const getEmptyColWidth = () => {
    if (isLarge) return 'auto';

    return 0;
  };

  return [
    {
      field: 'accountDescr',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-CUSTODIAN_ACCOUNTS' }),
      width: getAccountWidth(),
    },
    {
      field: 'account',
      title: TrlFormattedMessagePlain({ id: 'TRLT_UI-SECURITIES_ACCOUNTS' }),
      width: getAccountDescrWidth(),
    },
    {
      field: 'visible',
      cellTemplate: 'TrlButtonCell',
      type: 'checkbox',
      title: 'visibility',
      headerComponent: <EyeIconStyled icon={eye} />,
      fieldValue: 'account',
      handleChange: handleVisibleChange,
      disabledFieldValue: 'favorite',
      disableCondition: 'Y',
      headerClassName: 'customClassCenter',
      className: 'customClassCenter',
      width: '55px',
    },
    {
      field: 'r',
      cellTemplate: 'TrlButtonCell',
      type: 'radio',
      title: 'favorite',
      headerComponent: <StarIconStyled icon={star} />,
      fieldValue: 'account',
      selectedValue: favoriteValue,
      handleChange: handleFavoriteChange,
      headerClassName: 'customClassCenter',
      className: 'customClassCenter',
      width: '55px',
    },
    {
      field: 'space',
      width: getEmptyColWidth(),
    },
  ];
};
